var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{ref:"video",staticClass:"Video__video",attrs:{"autoplay":_vm.autoplay,"controls":_vm.showControls},domProps:{"muted":_vm.isMuted}},[_c('source',{attrs:{"src":_vm.source,"type":_vm.videoType}})])}
var staticRenderFns = []

export { render, staticRenderFns }